import { Grid, TableContainer, Paper, Table, TableHead, TableRow, TableBody, Tooltip, TablePagination, IconButton } from "@mui/material";
import { t } from "i18next";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import AppLoading from "../../Components/MDLoading";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { v4 as uuid } from "uuid";
import { useEffect, useState } from "react";
import { SubscriberModel } from "../../Api/Models/SubscriberModel";
import { SubscriberDto } from "../../Types/Api/DTO/SubscriberDto";
import { PaginatedResponse } from "../../Types/Api/Response";
import InfoIcon from "@mui/icons-material/Info";
import SubRows from "./components/Dialogs/SubRows";
import PrintIcon from "@mui/icons-material/Print";
import AddSubscriber from "./components/Dialogs/AddSubscriber";
export default function Subscribers() {
  const subscriberModel = new SubscriberModel();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(0);
  const [detailModal, setDetailModal] = useState({ show: false, rowId: 0 });
  const [AEDialog, setAEDialog] = useState({
    open: false,
  });
  const [rows, setRows] = useState<PaginatedResponse<SubscriberDto>>({
    content: [],
    pageSize: 0,
    totalPages: 0,
  });
  useEffect(() => {
    setLoading(true);
    subscriberModel
      .getAllWithPaginate(pageNumber, pageSize)
      .then((r) => {
        setRows(r.data.data);
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      subscriberModel.baseApi.handleCancelRequest();
    };
  }, [pageNumber, pageSize, counter]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage + 1);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPageSize(+event.target.value);
    setPageNumber(1);
  };
  function defaultLabelDisplayedRows({ from, to, count }: any) {
    return `${from}–${to} ${t("از")} ${count !== -1 ? count : `${t("more than")} ${to}`}`;
  }
  function _getSum(params: SubscriberDto[] | []) {
    if (params === []) return 0;

    let total = 0;
    for (let index = 0; index < params.length; index++) {
      total = total + parseInt(params[index].totalAmount);
    }
    return total;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar name={"مشترکین"}>
        <MDButton
          variant="outlined"
          color="dark"
          onClick={() => {
            setAEDialog({ open: true });
          }}
        >
          افزودن
        </MDButton>
      </DashboardNavbar>
      <MDBox py={3} bgColor="white" p={2} mb={2} flex={1} borderRadius={2}>
        <Grid container flexDirection={"column"}>
          <Grid item alignSelf={"flex-end"}>
            <IconButton onClick={() => window.open("/webroutes/AllSubscriber", "_blank")}>
              <PrintIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <TableContainer component={Paper}>
              <Table
                sx={{
                  minWidth: 700,
                }}
                aria-label="customized table"
              >
                <TableHead>
                  <TableRow>
                    <MDTableCell
                      align={"center"}
                      style={{
                        minWidth: 170,
                      }}
                    >
                      ردیف
                    </MDTableCell>
                    <MDTableCell
                      align={"center"}
                      style={{
                        minWidth: 170,
                      }}
                    >
                      شماره اشتراک
                    </MDTableCell>
                    <MDTableCell
                      align={"center"}
                      style={{
                        minWidth: 170,
                      }}
                    >
                      مبلغ کل
                    </MDTableCell>
                    <MDTableCell
                      align={"center"}
                      style={{
                        minWidth: 170,
                      }}
                    >
                      نوع قالب قبض
                    </MDTableCell>
                    <MDTableCell
                      align={"center"}
                      style={{
                        minWidth: 170,
                      }}
                    >
                      تعداد صادر شده
                    </MDTableCell>
                    <MDTableCell
                      align={"center"}
                      style={{
                        minWidth: 170,
                      }}
                    >
                      عملیات
                    </MDTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.content.length < 1 && (
                    <MDTableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <MDTableCell colSpan={6} align="right">
                        هیچ ردیفی وجود ندارد
                      </MDTableCell>
                    </MDTableRow>
                  )}
                  {rows.content.map((r, rowId) => {
                    return (
                      <MDTableRow hover role="checkbox" tabIndex={-1} key={uuid()}>
                        <MDTableCell align={"center"}>{r.id }</MDTableCell>
                        <MDTableCell align={"center"}>{r.subscriber}</MDTableCell>
                        <MDTableCell align={"center"}>{parseInt(r.totalAmount) + _getSum(r.children)}</MDTableCell>
                        <MDTableCell align={"center"}>{r.ghabzAvarezName}</MDTableCell>

                        <MDTableCell key={uuid()} align={"center"}>
                          {r.children.length + 1}
                        </MDTableCell>
                        <MDTableCell key={uuid()} align={"center"}>
                          <Tooltip title={"جزئیات"}>
                            <InfoIcon
                              onClick={() => {
                                setDetailModal({ show: true, rowId });
                              }}
                              color="info"
                              fontSize="medium"
                              sx={{
                                cursor: "pointer",
                                mx: 2,
                              }}
                            />
                          </Tooltip>{" "}
                        </MDTableCell>
                      </MDTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {rows?.content.length > 0 && (
              <>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rows.totalPages}
                  rowsPerPage={pageSize}
                  page={pageNumber - 1}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelDisplayedRows={defaultLabelDisplayedRows}
                  labelRowsPerPage={<>تعداد در هر ردیف </>}
                />
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      {detailModal.show && rows.content[0] && (
        <SubRows setCounter={setCounter} setDetailModal={setDetailModal} Subscribe={rows.content[detailModal.rowId]} />
      )}
      {AEDialog.open && (
        <AddSubscriber
          open={AEDialog.open}
          setClose={() => setAEDialog((r) => ({ ...r, open: false }))}
          onDone={() => setCounter((c) => c + 1)}
          loading={loading}
          setLoading={setLoading}
        />
      )}
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
